import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { PackageCard } from "../components/PackageCard";

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (q) api.get(`/search?q=${encodeURIComponent(q)}&limit=24`).then((r) => setItems(r.data));
  }, [q]);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="search-page">
      <span className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Search</span>
      <h1 className="font-serif-display text-5xl mt-2 mb-8">Results for "{q}"</h1>
      {items.length === 0 ? (
        <div className="text-muted-foreground">No matching packages.</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">{items.map((p) => <PackageCard key={p.slug} pkg={p} />)}</div>
      )}
    </div>
  );
}
